import { Skeleton } from '@crehana/compass.ui';

import { TrackingCardSkeleton } from './TrackingCard.skeleton';

export const TrackingDetailSkeleton = () => {
  return (
    <div className=" tw-inline-block tw-bg-neutral-light-100 tw-rounded-[10px] tw-p-2 tw-pt-4.4 tw-w-full">
      <div className="tw-pr-3.6">
        <Skeleton
          animated
          className="tw-h-1.6 tw-w-[16.2rem] tw-rounded-full tw-mb-0.8"
        />
        <Skeleton
          animated
          className="tw-h-[2.6rem] tw-w-full tw-rounded-full tw-mb-[4.2rem]"
        />
      </div>
      <div className="tw-pb-3.6">
        <TrackingCardSkeleton />
      </div>
      <div className="tw-pb-1.6">
        <TrackingCardSkeleton />
      </div>
    </div>
  );
};
